// 自动加载所有WebP资源
import type { WebpImageName } from '../types/_webp'

const webpModules = import.meta.glob('../assets/**/*.webp', {
  eager: true,
  query: '?url',
  import: 'default'
})

const webpMap: Record<string, string> = {}

// 遍历所有导入的WebP模块
Object.keys(webpModules).forEach((_path) => {
  // 从路径中提取相对于assets的路径
  const relativePath = _path.replace('../assets/', '')
  webpMap[relativePath] = webpModules[_path] as string
})

export function getWebpUrl(name: WebpImageName): string {
  return webpMap[name] || ''
}

// 获取所有可用的WebP图片名称
export function getAvailableWebpImages(): WebpImageName[] {
  return Object.keys(webpMap) as WebpImageName[]
}

// 生成类型定义（开发环境下）
if (import.meta.env.DEV) {
  generateWebpTypes()
}

// 生成WebP图片类型定义
function generateWebpTypes(): void {
  const imageNames = Object.keys(webpMap)
  const typeContent = `// 自动生成的WebP图片类型定义
// 请勿手动修改此文件

export type WebpImageName = ${imageNames.map((name) => `'${name}'`).join(' | ')}

// WebP图片组件的Props类型
export interface WebpImageProps {
  name: WebpImageName
  alt?: string
  width?: string | number
  height?: string | number
  className?: string
  loading?: 'lazy' | 'eager'
  objectFit?: 'contain' | 'cover' | 'fill' | 'scale-down' | 'none'
  quality?: number
}

// 图片名称数组
export const WEBP_IMAGE_NAMES = [${imageNames.map((name) => `'${name}'`).join(', ')}] as const

// 验证图片名称是否存在
export function isWebpImageName(name: string): name is WebpImageName {
  return WEBP_IMAGE_NAMES.includes(name as WebpImageName)
}

// 获取图片数量
export const WEBP_IMAGE_COUNT = ${imageNames.length}
`

  console.log('Generated WebP types:', typeContent)
}
